module.exports = __webpack_public_path__ + "static/media/logo.bc58801e.png";